import React, { useCallback } from 'react';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Switch from '@material-ui/core/Switch';

interface Props {
  value: boolean;
  onChange: (key: string, value: any) => void;
}

function Assistants({ value, onChange }: Props) {
  const enabled = !!value;

  const handleChangeEnabled = useCallback(
    function(e, isEnabled) {
      onChange('client.settings.assistants.enabled', isEnabled);
    },
    [onChange],
  );

  return (
    <Card>
      <CardHeader
        title="Assistants"
        action={
          <Switch
            inputProps={{ 'aria-label': 'assistants switch' }}
            onChange={handleChangeEnabled}
            checked={enabled}
          />
        }
        subheader="Allow users to add their assistants and people they assist to their profile."
      />
    </Card>
  );
}

export default Assistants;
